// This file was auto-generated by Fern from our API Definition.
import * as FernIr from "../../../../../index.mjs";
export const GithubPublishInfo = {
    npm: (value) => {
        return Object.assign(Object.assign({}, value), { type: "npm", _visit: function (visitor) {
                return FernIr.generatorExec.GithubPublishInfo._visit(this, visitor);
            } });
    },
    maven: (value) => {
        return Object.assign(Object.assign({}, value), { type: "maven", _visit: function (visitor) {
                return FernIr.generatorExec.GithubPublishInfo._visit(this, visitor);
            } });
    },
    postman: (value) => {
        return Object.assign(Object.assign({}, value), { type: "postman", _visit: function (visitor) {
                return FernIr.generatorExec.GithubPublishInfo._visit(this, visitor);
            } });
    },
    pypi: (value) => {
        return Object.assign(Object.assign({}, value), { type: "pypi", _visit: function (visitor) {
                return FernIr.generatorExec.GithubPublishInfo._visit(this, visitor);
            } });
    },
    rubygems: (value) => {
        return Object.assign(Object.assign({}, value), { type: "rubygems", _visit: function (visitor) {
                return FernIr.generatorExec.GithubPublishInfo._visit(this, visitor);
            } });
    },
    nuget: (value) => {
        return Object.assign(Object.assign({}, value), { type: "nuget", _visit: function (visitor) {
                return FernIr.generatorExec.GithubPublishInfo._visit(this, visitor);
            } });
    },
    crates: (value) => {
        return Object.assign(Object.assign({}, value), { type: "crates", _visit: function (visitor) {
                return FernIr.generatorExec.GithubPublishInfo._visit(this, visitor);
            } });
    },
    _visit: (value, visitor) => {
        switch (value.type) {
            case "npm":
                return visitor.npm(value);
            case "maven":
                return visitor.maven(value);
            case "postman":
                return visitor.postman(value);
            case "pypi":
                return visitor.pypi(value);
            case "rubygems":
                return visitor.rubygems(value);
            case "nuget":
                return visitor.nuget(value);
            case "crates":
                return visitor.crates(value);
            default:
                return visitor._other(value);
        }
    },
};
